import { useRoute } from '@react-navigation/native'
import { useMutation } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { getShareBrandURLV4 } from '@zet/feature-brands/api/brands/functions'

import { UserFlowRouteParams } from './types'

const useUserFlowApplyLink = (onApplySuccess?: () => void) => {
  const toast = useToast()
  const route = useRoute() as { params?: UserFlowRouteParams }
  const mutation = useMutation(getShareBrandURLV4)

  const openGeneratedLink = async ({
    partnerId,
    customerId,
    variantId,
  }: {
    partnerId?: number
    customerId: number
    variantId?: number
  }) => {
    try {
      const response = await mutation.mutateAsync({
        partnerId,
        customerId,
        leadSource: 'webBrand',
        brandSpecificPartnerId: route?.params?.brandSpecificPartnerId,
        variantId,
      })

      if (!response?.url) {
        toast?.show({
          intent: 'error',
          hideAfter: 3000,
          heading: 'Unable to open offer',
        })
        return
      }
      window.location.href = response?.url

      onApplySuccess?.()
    } catch (error: any) {
      toast?.show({
        intent: 'error',
        hideAfter: 3000,
        heading: error?.response?.data?.message || 'Something went wrong',
      })
    }
  }

  return {
    openGeneratedLink,
    isLoading: mutation?.isLoading,
  }
}

export default useUserFlowApplyLink
